var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "global d-flex flex-column"
  }, [_c('div', {
    staticClass: "scroll-ctn"
  }, [_vm.enabledLanguages.length === 1 ? _c('v-row', {
    staticClass: "my-7",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "translations-languages-selection"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations')) + " ")]), _c('div', {
    staticClass: "font-weight-light py-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_select_languages_description')) + " ")]), _c('v-autocomplete', {
    staticClass: "my-3",
    attrs: {
      "items": _vm.allLanguagesDropdown,
      "search-input": _vm.allLanguagesSearchInput,
      "item-text": "name",
      "item-value": "key",
      "chips": "",
      "label": _vm.$t('select_languages'),
      "placeholder": _vm.$t('search_languages'),
      "multiple": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.allLanguagesSearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.allLanguagesSearchInput = $event;
      },
      "change": function change($event) {
        _vm.allLanguagesSearchInput = '';
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function clickClose($event) {
              return _vm.removeSelectedTranslationLanguage(data.item);
            }
          }
        }, 'v-chip', data.attrs, false), [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }], null, false, 2974339869),
    model: {
      value: _vm.selectedTranslationLanguages,
      callback: function callback($$v) {
        _vm.selectedTranslationLanguages = $$v;
      },
      expression: "selectedTranslationLanguages"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedTranslationLanguages,
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": function click($event) {
        return _vm.addEnabledLanguages();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('continue')))])], 1)], 1)], 1) : _vm._e(), _vm.enabledLanguages.length > 1 ? _c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "align": "stretch",
      "id": "translations"
    }
  }, [_c('v-col', {
    staticClass: "translation-sidebar flex-grow-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "title pl-2 flex-grow-1"
  }, [_vm._v(_vm._s(_vm.$t('translations_language_list_title')))]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-2",
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.exportAllTranslations();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" mdi-download ")])], 1)];
      }
    }], null, false, 1537138171)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_export_all')))])])], 1), _c('div', {
    staticClass: "published-lang-ctn ma-3 py-1 text-center"
  }, [_vm._v(_vm._s(_vm.$t('translations_language_published', {
    publishedLanguages: _vm.published.reviewed_languages ? _vm.published.reviewed_languages.length : 0,
    totalLanguages: _vm.enabledLanguages.length
  })))]), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "my-3 btn-text-white",
    attrs: {
      "loading": _vm.translating,
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.machineTranslateDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_empty_state_machine_translate')) + " ")])], 1), _c('v-row', {
    staticClass: "font-weight-bold ma-0",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0 pl-2 my-1"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.$t('languages')))]), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.toggleLanguagesEditMode();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("$edit")])], 1)];
      }
    }], null, false, 3943118309)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_edit_languages')))])])], 1)]), _c('v-col', {
    staticClass: "ma-0 pa-0 pl-2 my-1",
    attrs: {
      "align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('translations_status')))])])], 1), _vm._l(_vm.enabledLanguagesSorted, function (lang) {
    return _c('v-row', {
      key: "languages-".concat(lang.key),
      staticClass: "language ma-0 px-3 py-0",
      class: {
        'selected': _vm.selectedLanguage === lang.key
      },
      attrs: {
        "align": "center",
        "justify": "space-between"
      },
      on: {
        "click": function click($event) {
          return _vm.selectLanguage(lang.key);
        }
      }
    }, [_c('v-col', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "cols": "8"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("languages_".concat(lang.key))) + _vm._s(lang.key === _vm.defaultLanguage ? " (".concat(_vm.$t('reference'), ")") : '') + " ")]), _c('v-col', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "cols": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('div', {
      staticClass: "lang-pill",
      class: _vm.getLangStatus(lang.key)
    }), _c('span', [_vm._v(_vm._s(_vm.$t("translations_lang_status_".concat(_vm.getLangStatus(lang.key)))))])])])], 1);
  }), _c('v-btn', {
    staticClass: "publish-btn btn-text-white my-2",
    attrs: {
      "color": "primary",
      "loading": _vm.publishing,
      "block": "",
      "raised": ""
    },
    on: {
      "click": function click($event) {
        return _vm.publish();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('publish_approved_languages')))]), _vm.published.reviewed_languages && _vm.published.reviewed_languages.length < _vm.enabledLanguages.length ? _c('v-btn', {
    staticClass: "publish-btn my-2",
    attrs: {
      "color": "primary",
      "outlined": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": function click($event) {
        _vm.bulkApproveDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('bulk_approve_and_publish_languages')))]) : _vm._e()], 2), _vm.selectedLanguage ? _c('v-col', {
    staticClass: "translation-content flex-grow-1"
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('div', {
    staticClass: "title my-2"
  }, [_vm._v(_vm._s(_vm.$t('translations_review_title')))]), _c('div', [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "hide-lg mr-2",
          attrs: {
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.expandPreview
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-cellphone-link")])], 1)];
      }
    }], null, false, 1740326170)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('preview_title')))])]), _vm.isPublishing ? _c('v-btn', {
    attrs: {
      "raised": "",
      "disabled": _vm.isPublishing
    }
  }, [_vm._v(_vm._s(_vm.$t('publishing')))]) : _vm.getLangStatus(_vm.selectedLanguage) === 'reviewing' ? _c('v-btn', {
    staticClass: "btn-text-white",
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.approveLanguage(_vm.selectedLanguage);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('translations_approve')))]) : _vm.getLangStatus(_vm.selectedLanguage) === 'approved' ? _c('v-btn', {
    staticClass: "btn-text-white",
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.publish([_vm.selectedLanguage]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('publish')))]) : _vm.getLangStatus(_vm.selectedLanguage) === 'published' && _vm.selectedLanguage !== _vm.defaultLanguage ? _c('v-btn', {
    staticClass: "btn-text-white",
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.unpublishLanguage(_vm.selectedLanguage);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('translations_unpublish')))]) : _vm._e()], 1)]), _vm.selectedLanguage !== _vm.defaultLanguage ? _c('v-row', {
    staticClass: "hint body-2 ma-0 py-2",
    attrs: {
      "align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_machine_translate_hint')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "translation-table"
  }, [_c('div', {
    staticClass: "translation-table-header d-flex align-center font-weight-bold"
  }, [_c('div', {
    staticClass: "min-w-60 pl-3"
  }, [_vm._v(_vm._s(_vm.$t('translations_review_reference')) + ": " + _vm._s(_vm.$t("languages_".concat(_vm.defaultLanguage))))]), _c('v-row', {
    staticClass: "ma-0 pl-2 py-2",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t("languages_".concat(_vm.selectedLanguage))))]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-4 btn-text-white",
          attrs: {
            "color": "white",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.exportTranslations();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" mdi-download ")])], 1)];
      }
    }], null, false, 2392903910)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_export')))])])], 1)], 1), _c('v-row', {
    staticClass: "translation-table-subheader font-weight-bold ma-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "min-w-60 ma-0 pa-0"
  }, [_c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "ma-0 pa-0"
  }, [_vm._v(_vm._s(_vm.$t('translations_table_field')))]), _c('v-col', {
    staticClass: "ma-0 pa-0 pl-2"
  }, [_vm._v(_vm._s(_vm.$t('translations_table_value')))])], 1)], 1), _c('v-col', {
    staticClass: "ma-0 pa-0 pl-2 py-1"
  }, [_c('v-row', {
    staticClass: "ma-0 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.$t('translations')))]), _vm.selectedLanguage !== _vm.defaultLanguage ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-lightbulb-outline")])];
      }
    }], null, false, 3386983215)
  }, [_c('div', {
    staticClass: "csv-hint"
  }, [_c('div', {
    staticClass: "hint-title mb-2"
  }, [_vm._v(_vm._s(_vm.$t('translations_csv_hint_1')) + ":")]), _c('ul', {
    staticClass: "my-2"
  }, [_c('li', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('translations_csv_hint_2')))]), _c('li', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('translations_csv_hint_3')))])]), _c('img', {
    attrs: {
      "src": require("@/assets/translation-csv-hint.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "warning font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('translations_csv_hint_4')))])])]) : _vm._e(), _c('v-spacer'), _vm.selectedLanguage !== _vm.defaultLanguage ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref6) {
        var on = _ref6.on,
          attrs = _ref6.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.translating,
            "disabled": _vm.translating,
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.machineTranslate();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-translate")])], 1)];
      }
    }], null, false, 3265535762)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_machine_translate_warning_title')))])]) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "translation-groups"
  }, _vm._l(_vm.groupedTranslations, function (groupItems, groupName, groupIndex) {
    return _c('div', {
      key: groupName,
      staticClass: "translation-group"
    }, [_c('v-row', {
      staticClass: "ma-0",
      attrs: {
        "align": "center"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleGroup(groupName);
        }
      }
    }, [_c('v-col', {
      staticClass: "group-header d-flex align-center ma-0 py-3 font-weight-bold"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.groupIcon(groupName)))]), _c('span', [_vm._v(_vm._s(_vm.groupTitle(groupName, groupIndex)))])], 1)], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.collapsedGroups[groupName],
        expression: "!collapsedGroups[groupName]"
      }]
    }, _vm._l(groupItems, function (item) {
      return _c('v-row', {
        key: "translations-".concat(_vm.selectedLanguage, "-").concat(item.key),
        staticClass: "group-row align-stretch"
      }, [_c('v-col', {
        staticClass: "min-w-60 ma-0 pa-0",
        class: item.type === 'divider' ? 'medium-gray-bg' : 'light-gray-bg'
      }, [_c('v-row', {
        staticClass: "ma-0",
        attrs: {
          "align": "start",
          "justify": "space-between"
        }
      }, [_c('v-col', {
        staticClass: "translation-key font-weight-bold"
      }, [_vm._v(" " + _vm._s(_vm.getI18nKey(item.key, item.subGroupNumber)) + " ")]), (item.type === 'image' || item.type === 'gallery') && _vm.isDisplayableImage(_vm.translatedStrings[item.key]) ? _c('v-col', {
        staticClass: "translation-value"
      }, [_c('img', {
        staticClass: "image-header",
        attrs: {
          "src": _vm.translatedStrings[item.key]
        }
      })]) : _vm.componentMapping[item.type] && item.element !== 'button' ? _c('div', {
        staticClass: "rich-text-container w-49"
      }, [_c(_vm.componentMapping[item.type], {
        ref: 'defaultLang-' + item.key,
        refInFor: true,
        tag: "component",
        attrs: {
          "content": _vm.translationsStrings[item.key],
          "is-translation-edit": true,
          "disable-rich-text": true,
          "child-classes": _vm.customClasses(item.type, true)
        },
        on: {
          "update:content": function updateContent($event) {
            return _vm.$set(_vm.translationsStrings, item.key, $event);
          }
        }
      })], 1) : _c('v-col', {
        staticClass: "translation-value"
      }, [_vm._v(_vm._s(item.value))])], 1)], 1), _vm.selectedLanguage !== _vm.defaultLanguage ? _c('v-col', {
        staticClass: "align-stretch ma-0 pa-0 max-w-40",
        class: {
          'outline-blue': item.type === 'image'
        }
      }, [item.type === 'image' || item.type === 'gallery' ? _c('div', {
        staticClass: "flex-shrink-0 mt-1"
      }, [!_vm.isEditingImageLink(item.key) ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('div', {
        staticClass: "d-flex ml-1"
      }, [item.type === 'image' ? _c('image-cropper', {
        attrs: {
          "input-key": "image-cropper-".concat(groupName, "-").concat(item.key),
          "tab-id": groupName,
          "icon": true
        },
        on: {
          "image-upload": function imageUpload(url) {
            return _vm.onImageUpload(item.key, url);
          }
        }
      }) : _vm._e(), item.type === 'image' ? _c('v-tooltip', {
        attrs: {
          "top": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function fn(_ref7) {
            var on = _ref7.on,
              attrs = _ref7.attrs;
            return [_vm.isAllowed('gallery_view') ? _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "icon": "",
                "color": "primary"
              },
              on: {
                "click": function click($event) {
                  return _vm.handleSTGalleryBtnClick(item.key);
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-image-outline")])], 1) : _vm._e()];
          }
        }], null, true)
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_select_image')))])]) : _vm._e(), item.type === 'image' && _vm.isAvailable('editor:tabs:tools:image:link') ? _c('v-tooltip', {
        attrs: {
          "top": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function fn(_ref8) {
            var on = _ref8.on,
              attrs = _ref8.attrs;
            return [_c('v-btn', _vm._g(_vm._b({
              attrs: {
                "color": "accent",
                "icon": ""
              },
              on: {
                "click": function click($event) {
                  return _vm.toggleImageEditMode(item.key, item.type);
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-link")])], 1)];
          }
        }], null, true)
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_add_picture')))])]) : _vm._e()], 1), _c('v-col', {
        staticClass: "translation-value cursor-default"
      }, [_vm._v(_vm._s(_vm.translatedStrings[item.key]))])], 1) : _vm._e(), _vm.isEditingImageLink(item.key) ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('div', {
        staticClass: "edit-image-toolbar"
      }, [_c('div', {
        staticClass: "edit-image-toolbar-actions"
      }, [_c('v-btn', {
        attrs: {
          "color": "accent",
          "icon": ""
        },
        on: {
          "click": function click($event) {
            return _vm.saveImageLink(item.key);
          }
        }
      }, [_c('v-icon', [_vm._v("$check")])], 1), _c('v-btn', {
        staticClass: "mr-1",
        attrs: {
          "color": "accent",
          "icon": ""
        },
        on: {
          "click": function click($event) {
            return _vm.cancelEditingImageLink(item.key);
          }
        }
      }, [_c('v-icon', [_vm._v("$cancel")])], 1)], 1)]), item.type === 'image' ? _c('image-edit', {
        attrs: {
          "content": _vm.tempImageLinks[item.key],
          "src": _vm.translatedStrings[item.key],
          "is-translation-edit": true
        },
        on: {
          "update:content": function updateContent($event) {
            return _vm.$set(_vm.tempImageLinks, item.key, $event);
          },
          "update:src": function updateSrc($event) {
            return _vm.$set(_vm.translatedStrings, item.key, $event);
          }
        }
      }) : _vm._e()], 1) : _vm._e(), _c('select-image-dialog', {
        attrs: {
          "display-select-image-dialog": _vm.activeGalleryKey === item.key,
          "app-tags": ['stc-editor-image'],
          "isAllowedEdit": _vm.isAllowed('gallery_edit')
        },
        on: {
          "update:displaySelectImageDialog": function updateDisplaySelectImageDialog($event) {
            return _vm.closeSTGalleryDialog();
          },
          "gallery-selected": function gallerySelected(url) {
            return _vm.handleSTGallerySelected(item.key, url);
          }
        }
      })], 1) : _vm.componentMapping[item.type] && item.element !== 'button' ? _c('div', {
        staticClass: "rich-text-container outline-blue",
        on: {
          "click": function click($event) {
            _vm.currentFieldIndex = item.cumulativeIndex;
          }
        }
      }, [_c(_vm.componentMapping[item.type], {
        ref: 'editor-' + item.key,
        refInFor: true,
        tag: "component",
        attrs: {
          "content": _vm.translatedStrings[item.key],
          "is-translation-edit": true,
          "child-classes": _vm.customClasses(item.type)
        },
        on: {
          "update:content": function updateContent($event) {
            return _vm.$set(_vm.translatedStrings, item.key, $event);
          },
          "rich-text-input-focused": function richTextInputFocused($event) {
            return _vm.handleRichTextFocus(item.key);
          },
          "rich-text-input-blurred": function richTextInputBlurred($event) {
            _vm.currentFieldIndex = null;
          }
        }
      })], 1) : _vm.isFileUrlItem(item) ? _c('div', {
        staticClass: "flex-shrink-0 mt-1"
      }, [_c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('div', {
        staticClass: "d-flex ml-1"
      }, [_vm.isAllowed('gallery_view') ? _c('v-tooltip', {
        attrs: {
          "top": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function fn(_ref9) {
            var on = _ref9.on,
              attrs = _ref9.attrs;
            return [_c('v-btn', _vm._g(_vm._b({
              attrs: {
                "icon": "",
                "color": "primary"
              },
              on: {
                "click": function click($event) {
                  return _vm.handleSTGalleryBtnClick(item.key);
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-file-pdf-box")])], 1)];
          }
        }], null, true)
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_select_document')))])]) : _vm._e()], 1), _c('v-textarea', {
        staticClass: "ma-0 custom-textarea",
        attrs: {
          "auto-grow": "",
          "rows": "1",
          "data-input-index": item.cumulativeIndex,
          "small": "",
          "dense": "",
          "hide-details": ""
        },
        on: {
          "input": function input($event) {
            return _vm.handleTextAreaInput(item.key, item.type);
          }
        },
        model: {
          value: _vm.translatedStrings[item.key],
          callback: function callback($$v) {
            _vm.$set(_vm.translatedStrings, item.key, $$v);
          },
          expression: "translatedStrings[item.key]"
        }
      })], 1), _c('select-image-dialog', {
        attrs: {
          "file-type": "pdf",
          "display-select-image-dialog": _vm.activeGalleryKey === item.key,
          "app-tags": ['stc-editor-image'],
          "isAllowedEdit": _vm.isAllowed('gallery_edit')
        },
        on: {
          "update:displaySelectImageDialog": function updateDisplaySelectImageDialog($event) {
            return _vm.closeSTGalleryDialog();
          },
          "gallery-selected": function gallerySelected(url) {
            return _vm.handleSTGallerySelected(item.key, url);
          }
        }
      })], 1) : _c('v-textarea', {
        staticClass: "ma-0 custom-textarea",
        attrs: {
          "auto-grow": "",
          "rows": "1",
          "data-input-index": item.cumulativeIndex,
          "small": "",
          "dense": "",
          "hide-details": ""
        },
        on: {
          "input": function input($event) {
            return _vm.handleTextAreaInput(item.key, item.type);
          },
          "keydown": function keydown($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
            return _vm.preventLineBreak(item.key, $event);
          }
        },
        model: {
          value: _vm.translatedStrings[item.key],
          callback: function callback($$v) {
            _vm.$set(_vm.translatedStrings, item.key, $$v);
          },
          expression: "translatedStrings[item.key]"
        }
      })], 1) : _c('v-col', {
        staticClass: "align-stretch ma-0 pa-0 max-w-40"
      }, [_vm.componentMapping[item.type] && item.element !== 'button' ? _c('div', {
        staticClass: "rich-text-container"
      }, [_c(_vm.componentMapping[item.type], {
        ref: 'editor-' + item.key,
        refInFor: true,
        tag: "component",
        attrs: {
          "content": _vm.translatedStrings[item.key],
          "is-translation-edit": true,
          "disable-rich-text": true,
          "child-classes": _vm.customClasses(item.type)
        },
        on: {
          "update:content": function updateContent($event) {
            return _vm.$set(_vm.translatedStrings, item.key, $event);
          }
        }
      })], 1) : _c('v-col', {
        staticClass: "translation-value"
      }, [_vm._v(_vm._s(item.value))])], 1)], 1);
    }), 1)], 1);
  }), 0)], 1)], 1) : _vm._e()], 1) : _vm._e(), _c('language-edit-modal', {
    attrs: {
      "allow-translations-edit": true
    },
    on: {
      "default-language-changed": _vm.selectLanguage,
      "translation-languages-changed": _vm.onTranslationLanguagesChanged
    },
    model: {
      value: _vm.languagesEditDialog,
      callback: function callback($$v) {
        _vm.languagesEditDialog = $$v;
      },
      expression: "languagesEditDialog"
    }
  }), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.bulkApproveDialog,
      callback: function callback($$v) {
        _vm.bulkApproveDialog = $$v;
      },
      expression: "bulkApproveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('translations_bulk_approve_and_publish_title')) + " ")]), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mt-2",
    attrs: {
      "solo": "",
      "search-input": _vm.enabledLanguagesSearchInput,
      "multiple": "",
      "items": _vm.enabledLanguagesDropdown,
      "item-value": "key",
      "item-text": "name"
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.enabledLanguagesSearchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.enabledLanguagesSearchInput = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref10) {
        var item = _ref10.item,
          on = _ref10.on,
          attrs = _ref10.attrs;
        return [_c('v-list-item', _vm._g(_vm._b({}, 'v-list-item', attrs, false), on), [_c('v-checkbox', {
          model: {
            value: attrs.inputValue,
            callback: function callback($$v) {
              _vm.$set(attrs, "inputValue", $$v);
            },
            expression: "attrs.inputValue"
          }
        }), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.name) + " ")])], 1)], 1)];
      }
    }], null, false, 140725982),
    model: {
      value: _vm.languagesToPublish,
      callback: function callback($$v) {
        _vm.languagesToPublish = $$v;
      },
      expression: "languagesToPublish"
    }
  }), _c('div', [_vm._v(_vm._s(_vm.$t('translation_bulk_approve_disclaimer')))])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.bulkApproveDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    staticClass: "btn-text-white",
    attrs: {
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.bulkApproveAndPublish(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_approve_and_publish')) + " ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "500"
    },
    model: {
      value: _vm.machineTranslateDialog,
      callback: function callback($$v) {
        _vm.machineTranslateDialog = $$v;
      },
      expression: "machineTranslateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('translations_machine_translate_warning_title')))]), _c('v-card-text', [_c('div', {
    staticClass: "my-3 body-1"
  }, [_vm._v(" " + _vm._s(_vm.$t('translations_machine_translate_warning_description')) + " ")])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.machineTranslateDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "raised": "",
      "color": "primary",
      "loading": _vm.translating,
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.translateAllLanguages(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('translations_empty_state_machine_translate')))])], 1)], 1)], 1)], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }